import React from "react";
import "./singlePost.css";

export default function SinglePost() {
    return (
        <div className="single__post">
            <h4>봄은 꽃이다, 서초 양재꽃시장과 양재천 벚꽃길</h4>
            <div className="desc">
                <p>
                    서울 양재꽃시장은 화훼공판장과 F스퀘어로 나뉜다. 1991년에 문을 연 화훼공판장은 전국 최대 규모 법정
                    도매시장으로, 봄이 되면 화사한 빛깔로 가득하다. 노란 프리지어부터 빨간 튤립, 신비로운 파란색
                    카네이션까지 보는 눈이 즐겁다. 분화매장은 온실 형태라 친구나 가족과 봄나들이에 제격이다. 화분에 심은
                    수선화와 제라늄, 수국은 물론, 관엽식물과 다육식물, 난, 조경수 등을 판매한다. 2019년 문을 연
                    F스퀘어는 꽃의 새로운 가치를 알리는 복합 문화 공간이다. 플라워 레슨과 원예 치료 프로그램 등을
                    운영했으나, 현재 코로나19 확산 방지를 위해 휴관 중이다. 양재꽃시장에서 10분 남짓 걸어가면 양재천
                    산책로를 만난다. 3월 하순부터 4월 초순에 벚꽃이 흐드러져 봄 향기가 그윽하다.
                </p>
                <p>
                    양재꽃시장과 이웃한 시민의숲도 연둣빛 봄이 만발한다. 울창한 숲과 함께 잔디광장, 분수, 어린이놀이터,
                    바비큐장 등 편의 시설을 갖췄다. 국민이 성금을 모아 건립한 매헌윤봉길의사기념관은 들어서는 순간부터
                    태극기를 배경으로 앉은 의사의 동상이 절로 숙연한 마음이 들게 한다. 양재천 벚꽃길을 찾았다면 핫
                    플레이스로 꼽히는 카페거리도 들러보자. 문의 : 서초구청 문화관광과 02-2155-6200
                </p>
            </div>
        </div>
    );
}
